import React, {useLayoutEffect} from "react";

import { IoChevronBack } from "react-icons/io5";
/*** REUSABLE COMPONENTS ***/
import FlatList from "../../../components/FlatList";
import AudioScrollableCard from "../../../components/audio/ScrollableCard/AudioScrollableCard";

/** loading */
import HomePageSkeleton from "../../../components/skeletonLoading/HomePageSkeleton";

import { useFetchAudioPurchasedBookDataQuery } from "../../../api/audioPurchasedBookPageApi";
import { useNavigate, useParams } from "react-router";

import { NotFound } from "../../error/NotFound_404";
import { useNavbar } from "../../../context/NavBarContext";

const Index = () => {
  const Navbar = useNavbar();
  const { data, error, isLoading, isFetching } = useFetchAudioPurchasedBookDataQuery();

  console.log("data is here");
  console.log(data);    

  useLayoutEffect(() => {
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  }, []);

  if (isLoading) {
    return <HomePageSkeleton audio={true} />;
  }

  if (error) {
    return <NotFound error={error} />;
  }

  const BookCard = ({ item }) => {
    const navigate = useNavigate();
  
    const handleClick = () => {
      navigate(`/audio/book-series/${item.series}`);
    };
  
    return (
      <div 
        className="flex flex-col cursor-pointer py-3 transform transition-transform hover:scale-105"
        onClick={handleClick}
      >
        <div className="relative rounded-lg overflow-hidden shadow-lg">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-48 object-cover"
            onError={(e) => {
              e.target.src = '/placeholder-book.jpg'; // fallback image
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        </div>
        <div className="mt-2 px-1">
          <p className="text-sm  my-2 font-medium text-gray-800 dark:text-gray-200  leading-tight">
            {item.title}
          </p>
        </div>
      </div>
    )
  }


  return (
    <>
    <div className={`grid gap-4  
            grid-cols-2
          `}>
          {data.result.map((item, index) => {
              const key = item.series || index;
                return (
                  <BookCard
                    key={key}
                    item={item}
                    
                  />
                )
              }
            )}
    </div>
    </>
  );
};

export default Index;
